// libs
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

import {
    MENU_TYPE,
    VIEW_TYPES,
    TYPES,
    MENU_TAGS,
    MENU_NAMES,
} from "shared/components/Header/constants";

// def
interface IGetMenuDataProps {
    menu: Menu.IChildrenData;
    level: number;
    parent?: MENU_TYPE;
    channel?: string[];
    filterData?: string;
    sort?: string;
}

interface IGetMenuDataChildrenProps {
    menu: Menu.IChildrenData;
    parent?: MENU_TYPE;
    channel?: string[];
    level?: number;
}

const getMenuData = ({ menu, level, parent, channel = [] }: IGetMenuDataProps) => {
    let menuType: MENU_TYPE = MENU_TYPE.CATEGORY;
    let customData: { [key: string]: string } = {};

    const menu_type_from_data = get(menu, "type", "").toUpperCase();

    switch (parent) {
        case MENU_TYPE.CATEGORY: {
            menuType = MENU_TYPE.SUBCATEGORY;
            customData["mode"] = menu.mode;
            break;
        }
        case MENU_TYPE.SUBCATEGORY: {
            menuType = MENU_TYPE.SUB_LINK;
            customData["url"] = menu.action_url;
            break;
        }
        case MENU_TYPE.BIG_IMAGE:
        case MENU_TYPE.TOP_CATEGORIES: {
            menuType = MENU_TYPE.IMAGE;
            customData["url"] = menu.action_url;
            customData["image_url"] = menu.image_url;
            customData["aspect_ratio"] = menu.aspect_ratio;
            break;
        }
    }

    let menuTag = undefined;
    if (get(menu, "name", "").toUpperCase() === MENU_NAMES[MENU_TAGS.WHATS_NEW]) {
        menuTag = MENU_TAGS.WHATS_NEW;
    }
    if (get(menu, "name", "").toUpperCase() === MENU_NAMES[MENU_TAGS.BRANDS]) {
        menuTag = MENU_TAGS.BRANDS;
    }

    if (
        get(menu, "view_type", "").toUpperCase() === VIEW_TYPES.LIST &&
        (get(menu, "column_count", 0) === "1" || get(menu, "column_count", 0) === 1)
    ) {
        menuType = MENU_TYPE.BIG_IMAGE;
    }

    if (
        get(menu, "view_type", "").toUpperCase() === VIEW_TYPES.CARD &&
        (get(menu, "column_count", 0) === "2" || get(menu, "column_count", 0) === 2)
    ) {
        menuType = MENU_TYPE.TOP_CATEGORIES;
    }

    if (menu_type_from_data === TYPES.LINK) {
        menuType = MENU_TYPE.SUB_LINK_HIGHLIGHT;
        customData["url"] = menu.action_url;
    }

    if (menu.weburl !== undefined) {
        menuType = MENU_TYPE.LINK;
        customData["url"] = menu.weburl;
    }

    if (!isEmpty(menu.dynamicUrl)) {
        menuType = MENU_TYPE.SALE;
        customData["url"] = menu.action_url;
    }

    if (menu_type_from_data === TYPES.AD_PLATFORM) {
        menuType = MENU_TYPE.AD_PLATFORM_LINK;
        customData["url"] = menu.action_url;
    }

    const channelForChildren = menu.name ? [...channel, menu.name] : channel;
    const children = getMenuDataChildren({
        menu,
        parent: menuType,
        channel: channelForChildren,
        level: level + 1,
    });
    if (menuType === MENU_TYPE.CATEGORY && children.length === 0) {
        menuType = MENU_TYPE.LINK;
        customData["url"] = menu.action_url;
    }

    customData["channel"] = channel.join(",");
    customData["level"] = level.toString();

    return {
        id: menu.id,
        title: menu.name,
        type: menuType,
        children: children,
        tag: menuTag,
        device: menu.device,
        isActive: menu.is_active || true,
        filterData: menu.filter_data,
        sort: menu.sort,
        ...customData,
    };
};

const getMenuDataChildren = ({ menu, parent, channel, level = 1 }: IGetMenuDataChildrenProps) => {
    return get(menu, "children_data", []).map((data: Menu.IChildrenData) =>
        getMenuData({ menu: data, level, parent, channel })
    );
};

export const NormalizeMenu = (data: Menu.IChildrenData) => {
    const newData = getMenuDataChildren({ menu: data });
    return newData;
};
